import { Box, Grid, Typography } from "@mui/material";
import { RoomBoxColour } from "../../constants/pojoservice";
import { BillStatus } from "../../constants/Constants";

const BillingStatusGrid = () => {
  const billStatusArray = [
    { billStatus: BillStatus.ROOMALLOTEDPARTIALPAID, name: "Room Alloted & Partial Paid" },
    { billStatus: BillStatus.ROOMALLOTEDPAID, name: "Room Alloted & Paid" },
    { billStatus: BillStatus.ROOMALLOTEDNOTPAID, name: "Room Alloted But Not Paid" },
    { billStatus: BillStatus.ROOMALLOTEDPAIDBUTRESTAURANTNOTPAID, name: "Room Alloted & Paid\n But Restaurant Not Paid" }
  ];
  return (
    <>
      {billStatusArray.map((item, index) => (
        <Grid
          item
          xs={6}
          sm={4}
          md={3}
          key={index}
          sx={{ display: "flex", alignItems: "center" }}
        >
          {/* Color Box */}
          <Box
            sx={{
              width: 20,
              height: 20,
              backgroundColor: RoomBoxColour({ billStatus: item.billStatus }),
              borderRadius: "4px",
              marginRight: "8px",
              border: "1px solid #ccc"
            }}
          />
          {/* Name with Line Breaks */}
          <Typography
            variant="p"
            sx={{ whiteSpace: "pre-line", fontWeight: 300 }}
          >
            {item.name}
          </Typography>
        </Grid>
      ))}
    </>
  );
};

export { BillingStatusGrid };